// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React, { FC } from 'react';

export interface RadioButtonProps {
    errorMsg?: string;
    isDisabled?: boolean;
    children: React.ReactNode;
}

const RadioButton: FC<RadioButtonProps> = ({
    errorMsg,
    isDisabled,
    children,
}) => {
    return (
        <div className="radio-button-group">
            {React.Children.map(children, child => {
                return (
                    <div className="radio-button-item">
                        {React.cloneElement(child as React.ReactElement, { disabled: isDisabled })}
                    </div>
                );
            })}
            {errorMsg && <span>{errorMsg}</span>}
        </div>
    );
};

export default RadioButton;
